import { RECEIVED_REPORT_RUNS, ERROR_RECEIVED } from './type';

const INITIAL_STATE = {
  reports: [],
  error: null,
};

export default function reducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case RECEIVED_REPORT_RUNS:
      return {
        ...state,
        reports: action.payload,
      };

    case ERROR_RECEIVED:
      return {
        ...state,
        error: 'Failed to load reports',
      };

    default:
      return state;
  }
}
